module.exports = __webpack_public_path__ + "a0f25e54fdde53f58a6ca4bbf828fee3.svg";